import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export const environmentsPage = PageBlueprint.make({
  name: 'environments',
  params: {
    path: '/environments',
    title: 'Environments',
    loader: async () =>
      import('./EnvironmentsPage').then(module => <module.EnvironmentsPage />),
  },
});

export const entityEnvironmentsCard = EntityCardBlueprint.make({
  name: 'environments',
  params: {
    type: 'info',
    filter: entity => entity.kind.toLocaleLowerCase('en-US') === 'component',
    loader: async () =>
      import('./EntityEnvironmentsCard').then(module => (
        <module.EntityEnvironmentsCard />
      )),
  },
});

export const environmentsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [environmentsPage, entityEnvironmentsCard],
});
